import type { LawyerRow } from "./lawyerRows";

export type LawyerRowFilters = {
  search?: string;
  submission?: string;
  reviewStatus?: string;
};

export function filterLawyerRows(rows: LawyerRow[], filters: LawyerRowFilters): LawyerRow[] {
  const { search, submission, reviewStatus } = filters;

  return rows.filter(row => {
    const matchesSearch =
      !search ||
      row.name.toLowerCase().includes(search.toLowerCase()) ||
      row.organisationName.toLowerCase().includes(search.toLowerCase());
    const matchesSubmission =
      !submission || (submission === "true" ? row.hasSubmission : !row.hasSubmission);
    const matchesReviewStatus =
      !reviewStatus ||
      row.reviewStatus === reviewStatus ||
      (reviewStatus === "not_started" && !row.reviewStatus) ||
      Object.values(row.contentByTable ?? {}).some(
        c => c.reviewStatus === reviewStatus || (reviewStatus === "not_started" && !c.reviewStatus),
      );
    return matchesSearch && matchesSubmission && matchesReviewStatus;
  });
}
